export default {
    introduction: {
        title: 'Searching in the Trademarks Register and the Business Register',
        body: 'Enter the name you want to use for your new business or organisation into the search bar. Then, you can check whether that name has already been registered as a trade or company name, or as a trademark.',
        bodyLink: '/en/entrepreneurs/faq#what-do-i-need-to-look-out-for-when-using-name-checker',
        bodyLinkText: 'Read about what you should take into account',
        listHeading: 'Search tips',
        listPointOne: 'Also search for parts of your name. So, if your name is ‘Krissie Krassie Coaching’, also search for ‘Krissie’ and ‘Krassie’. It is especially important to search for the most unique part of your name.',
        listPointTwo: 'The tool cannot search by sound (phonetically), but if your name sounds very similar to another trade name, it can be confusing. So, do not just search for ‘Daamen’, for example, but also for ‘Damen’ and ‘Danen’.',
    },
    reminder: {
        body: 'What do I need to look out for? Read more about using the ',
        namechecker: 'Name checker',
    },
    result: {
        type: 'Type: ',
    },
    results: {
        count: 'result | results',
    },
    resultsError: {
        title: 'Sorry, something went wrong',
        body: 'There is an error that prevents us from showing search results. Please come back later.',
    },
    search: {
        introTitle: 'Check if your name is already in use',
        boipResultsTitle: 'BOIP Trademarks Register',
        boipNoResults: 'No search results for trademarks.',
        boipCountResults: '{count} result for trademarks. | {count} of {total} results for trademarks.',
        boipResultsLinkText: 'View Trademarks Register results',
        kvkResultsTitle: 'Chamber of Commerce Business Register',
        kvkNoResults: 'No search results for trade names.',
        kvkCountResults: '{count} result for trade names. | {count} of {total} results for trade names.',
        kvkResultsLinkText: 'View Business Register results and exceptions',
        resultsFound: '"{term}" already appears in the Trademarks Register or Business Register',
        noResultsFound: 'Good news, "{term}" doesn\'t appear in the Trademarks Register or Business Register.',
        errorFound: '"{term}" couldn\'t be found due to an error in the Trademarks Register and Business Register.',
    },
    searchBox: {
        inputPlaceholder: 'Search in the BOIP Trademarks Register and the Chamber of Commerce Business Register',
        buttonLabel: 'Search',
    },
    infoButton: {
        kvkButton: 'Trade Name information',
        boipButton: 'Trademark information',
    },
    tradeMark: {
        applicationNumber: 'Filing number',
        depotDate: 'Filing date',
        goodsAndServices: 'Goods and services',
        goodsAndServicesPrefix: 'CL',
        resultInfo: 'Do you see any results? Then click the link below to continue your research.',
        resultsNoInfo: 'The name you have entered does not appear in the Trademarks Register. That does not automatically mean you may use it.',
        faqText: 'View the FAQ below.',
    },
    branch: {
        applicationNumber: 'Chamber of Commerce number',
        address: 'Address',
        tradeName: 'Trade name',
        tradeNames: 'Trade names',
        resultInfo: 'Want to see all the results? Or looking for information about exceptions that will allow you to use the name after all?',
        resultsNoInfo: 'The name you have entered does not appear in the Business Register, but it exists in the Trademarks Register. Using this name may lead to an unwelcome situation between you and another party.',
    },
};
